/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button/Button';
import {
    object, func, string,
} from 'prop-types';

const ErrorDialog = ({
    classes, closeModal, openModal, errorMessage,
}) => (
    <Dialog
        onClose={closeModal}
        open={openModal}
    >
        <DialogContent>
            <DialogContentText className={classes.errorText}>
                {errorMessage}
            </DialogContentText>
        </DialogContent>
        <DialogActions className="DialogAction">
            <Button disableFocusRipple onClick={closeModal} className={classes.errorCloseBtn} autoFocus>
                <strong>Close</strong>
            </Button>

        </DialogActions>
    </Dialog>
);

ErrorDialog.defaultProps = {
    errorMessage: '',
};

ErrorDialog.propTypes = {
    errorMessage: string,
    classes: object.isRequired,
    closeModal: func.isRequired,
    openModal: func.isRequired,
};

export default ErrorDialog;
